import axios from 'axios';
import HttpClient from '../utils/HttpClient';
import projectStore from '@/store/Projects';
import { getInstance } from '../auth';
export default {
  getCostGroups(projectId, cb) {
    const instance = getInstance();
    instance.getTokenSilently().then(authToken => {
      axios.defaults.headers.common['Authorization'] = `Bearer ${authToken}`;
      axios
        .get(`/api/projects/${projectId}/costgroups`)
        .then(data => cb(data.data, null))
        .catch(error => cb(null, error));
    });
  },
  getCostGroupById(CostGroupId) {
    return HttpClient.getAuthenticated(`/api/projects/${projectStore.activeProject.DbId}/costgroups/${CostGroupId}`);
  },
  getCostGroupAllocations(CostGroupId) {
    return HttpClient.getAuthenticated(
      `/api/projects/${projectStore.activeProject.DbId}/costgroups/${CostGroupId}/allocations`
    );
  },
  getBudgetSourcesWithBudget(budgetSourceType) {
    return HttpClient.getAuthenticated(`/api/projects/${projectStore.activeProject.DbId}/${budgetSourceType}/budgets`);
  },
  getBudgetSourceById(id, budgetSourceType) {
    return HttpClient.getAuthenticated(
      `/api/projects/${projectStore.activeProject.DbId}/${budgetSourceType}/${id}/budget`
    );
  },
  createNewCostGroup(projectId, costGroup, cb) {
    HttpClient.postAuthenticated(`/api/projects/${projectId}/costgroups`, { costGroup: costGroup })
      .then(result => cb(null, result[0]))
      .catch(err => cb(err, null));
  },
  createAllocation(allocation) {
    return HttpClient.postAuthenticated(`/api/projects/${projectStore.activeProject.DbId}/allocations`, { allocation });
  },
  createBulk(projectId, costGroups, overwriteOption, cb) {
    HttpClient.postAuthenticated(`/api/projects/${projectId}/costgroups`, { costGroups: costGroups, overwriteOption })
      .then(() => cb())
      .catch(err => cb(err));
  },
  deleteCostGroup(projectId, costGroupDbId, cb) {
    HttpClient.deleteAuthenticated(`/api/projects/${projectId}/costgroups/${costGroupDbId}`)
      .then(() => cb())
      .catch(err => cb(err));
  },
  deleteCostGroups(costGroups) {
    return HttpClient.deleteAuthenticated(`/api/projects/${projectStore.activeProject.DbId}/costgroups`, costGroups);
  },
  deleteAllocation(allocation) {
    return HttpClient.deleteAuthenticated(
      `/api/projects/${projectStore.activeProject.DbId}/allocations/${allocation.Source}/${allocation.RefDbId}`,
      { allocation }
    );
  },
  updateCostGroup(costGroup) {
    return HttpClient.updateAuthenticated(
      `/api/projects/${projectStore.activeProject.DbId}/costgroups/${costGroup.DbId}`,
      { costGroup }
    );
  },
  updateAllocation(allocation) {
    console.log('bubu', allocation);
    return HttpClient.updateAuthenticated(
      `/api/projects/${projectStore.activeProject.DbId}/allocations/kke/${allocation.RefDbId}`,
      { allocation }
    );
  },
  downloadAsXLS() {
    return HttpClient.downloadAuthenticated(
      `/api/projects/${projectStore.activeProject.DbId}/costgroups/downloadAsXLS`
    );
  },
  allocateCostGroupToMultipleAllocationUnits(workItem) {
    return HttpClient.postAuthenticated(
      `/api/projects/${projectStore.activeProject.DbId}/costgroups/allocateCostGroupToMultipleAllocationUnits`,
      { workItem }
    );
  }
};
